import React from 'react';

import { classNames } from '@core/utils/functions/class-names';

type IFilterProps = {
    className?: string;
    style?: 'gray' | 'black';
    width?: number;
    height?: number;
};

const FilterIcon = (props: IFilterProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width}
            height={props.height}
            viewBox="0 0 12 13"
            fill="none"
            className={classNames(
                'relative',
                props.style === 'gray' ? 'text-light-gray' : 'text-black',
                props.className
            )}
        >
            <path
                d="M0.158703 1.49339C1.6737 3.43589 4.4712 7.03589 4.4712 7.03589V11.5359C4.4712 11.9484 4.8087 12.2859 5.2212 12.2859H6.7212C7.1337 12.2859 7.4712 11.9484 7.4712 11.5359V7.03589C7.4712 7.03589 10.2612 3.43589 11.7762 1.49339C12.1587 0.998389 11.8062 0.285889 11.1837 0.285889H0.751203C0.128703 0.285889 -0.223797 0.998389 0.158703 1.49339Z"
                fill="#6A6A6A"
            />
        </svg>
    );
};

export default FilterIcon;
